import { Dispatch } from "@reduxjs/toolkit";
import { setAuthData, setLoading, setAuthError, setIdConnection, setUserData, logout } from "./authSlice";
import { loginRequest } from "../../../api/authApi";
import { AuthResponse } from "../../../interfaces/auth.interface";
import { AxiosError, AxiosResponse } from "axios";

import $ from 'jquery';
import { ACCOUNT_ENTRIES_COMPANIES, ACCOUNT_ENTRIES_GET_ACTIVE_GROUP, ACCOUNT_ENTRIES_GET_DOCUMENT_DATA, ACCOUNT_ENTRIES_GET_DOCUMENT_RESOURCES, ACCOUNT_ENTRIES_GET_GROUP_DETAILS, ACCOUNT_ENTRIES_LIST_GROUPS, ACCOUNT_ENTRIES_PERIODS, ACCOUNT_ENTRIES_SAVE_NEW_GROUP, ACCOUNT_ENTRIES_SCHEME, ACCOUNT_ENTRIES_SET_DEFAULT_GROUP, ACCOUNT_ENTRIES_VFLEX_CONFIGURATION, GET_EMPLOYEE_INFORMATION } from "../../../constants/signalRequestConsts";
import { Scenarios } from "../../../constants/scenarios";
import { setActiveGroup, setCompanies, setDocumentData, setDocumentResources, setGroupDetails, setPeriods, setScheme, setUserGroups, setVFlexConfig } from "../account-entries";


interface JqueryInterface extends JQueryStatic {
    hubConnection?: any
}
declare global {
    interface Window {
        jQuery: JqueryInterface;
    }
}

const jsquery: JqueryInterface = $;

window.jQuery = jsquery;
require('signalr');

const parseSignalRequestName = (name: string): { requestId: string; scenario: Scenarios | null } => {
    for (const scenario of Object.values(Scenarios)) {
        const suffix = `_${scenario}`;
        if (name.endsWith(suffix)) {
            return {
                requestId: name.slice(0, name.length - suffix.length),
                scenario,
            };
        }
    }
    return { requestId: name, scenario: null };
};

export interface LoginData {
    UserName: string;
    Password: string;
}

export const loginUser = (loginData: LoginData) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoading(true));
        dispatch(setAuthError(""));
        const response: AuthResponse = await loginRequest(loginData)
            .then((resp: AxiosResponse<AuthResponse>) => {
                if (resp?.status !== 200 || resp.data?.Type !== 0 || !resp.data?.Value?.Companies?.length) {
                    return {
                        Type: 1,
                        Message: resp?.status !== 200
                            ? "Error, reintenta nuevamente en unos minutos o comunicate con el administrador."
                            : resp.data.Type === 1
                                ? resp.data.Message
                                : "Error, la informacion de tu usuario no es válida, por favor contacta al administrador.",
                        Value: null as any,
                    }
                }
                return {
                    Type: 0,
                    Message: "",
                    Value: resp.data.Value,
                }
            })
            .catch((e: AxiosError) => {
                if (e.code !== "ERR_NETWORK") {
                    console.log(e);
                }
                return {
                    Type: 1,
                    Message: e.code === "ERR_NETWORK"
                        ? "Error de conexión, por favor revisa tu conexión de internet."
                        : "Error desconocido.",
                    Value: null as any,
                }
            });
        if (response.Type === 1) {
            dispatch(setAuthError(response.Message));
        } else {
            dispatch(setAuthData(response.Value));
        }
        dispatch(setLoading(false));
    }

}

export const refreshToken = (token: string) => {
    return async (dispatch: Dispatch) => {
        var options = {
            qs: {
                AuthType: process.env.REACT_APP_AUTH_TYPE,
                Token: token,
                ModuleId: process.env.REACT_APP_MODULE_ID,
            }
        };
        const connection = jsquery.hubConnection(process.env.REACT_APP_SIGNALR_URL, options);
        const hubProxy = connection.createHubProxy(process.env.REACT_APP_SIGNALR_PROXY);

        hubProxy.on(process.env.REACT_APP_SIGNALR_RECEIVE, function (response: any) {
            const data = JSON.parse(response);
            const { requestId, scenario } = parseSignalRequestName(data.Name);
            const finalScenario = scenario ?? Scenarios.LibroDiarioEscenario;
            const finalData = {
                // ...data,
                requestId,
                data: JSON.parse(data.Data),
                count: data.Count,
                part: data.Part, 
                totalItems: data.OutputValue?.split("/")[1] ? Number(data.OutputValue?.split("/")[1]) : null,
            }
            switch (requestId) {
                case GET_EMPLOYEE_INFORMATION:
                    dispatch(setUserData(finalData.data[0]));
                    break
                case ACCOUNT_ENTRIES_COMPANIES:
                    dispatch(setCompanies(finalData));
                    break
                case ACCOUNT_ENTRIES_GET_ACTIVE_GROUP:
                    dispatch(setActiveGroup({ ...finalData, scenario: finalScenario }));
                    break;
                case ACCOUNT_ENTRIES_LIST_GROUPS:
                    dispatch(setUserGroups({ ...finalData, scenario: finalScenario }));
                    break;
                case ACCOUNT_ENTRIES_GET_GROUP_DETAILS:
                    dispatch(setGroupDetails({ ...finalData, scenario: finalScenario }));
                    break;
                case ACCOUNT_ENTRIES_SAVE_NEW_GROUP:
                case ACCOUNT_ENTRIES_SET_DEFAULT_GROUP:
                    console.log('finalData', finalData)
                    break

                case ACCOUNT_ENTRIES_GET_DOCUMENT_RESOURCES:
                    dispatch(setDocumentResources(finalData));
                    break

                    
                case ACCOUNT_ENTRIES_SCHEME:
                    dispatch(setScheme(finalData));
                    break
                case ACCOUNT_ENTRIES_PERIODS:
                    dispatch(setPeriods(finalData));
                    break
                case ACCOUNT_ENTRIES_VFLEX_CONFIGURATION:
                    console.log('ACCOUNT_ENTRIES_VFLEX_CONFIGURATION', scenario, finalData)
                    dispatch(setVFlexConfig({ ...finalData, scenario: finalScenario }));
                    break
                case ACCOUNT_ENTRIES_GET_DOCUMENT_DATA:
                    dispatch(setDocumentData(finalData));
                    break
                default:
                    console.log(requestId, finalData)
                    dispatch({
                        type: requestId,
                        payload: finalData,
                    })
                    break;
            }
        });
        // connect
        connection
            .start()
            .done(function () {
                console.log("Now connected, connection ID=" + connection.id);
                dispatch(setIdConnection(connection.id));
            })
            .fail(function () {
                console.log("Could not connect");
                dispatch(logout());
                // alert("Conexion fallida, posiblemente token vencido");
                // dispatch({
                // 	type: 'REFRESH_IDCONNECTION',
                // 	payload: false
                // });
            });
    }
}
